export const NIKUD = {
    HATAF_SEGOL: 'ֱ',   HATAF_PATAH: 'ֲ',   HATAF_QAMATZ: 'ֳ',    HIRIQ: 'ִ',     TSERE: 'ֵ',   SEGOL: 'ֶ',
    PATAH: 'ַ',  QAMATZ: 'ָ',  HOLAM: 'ֹ',   QUBUTZ: 'ֻ',   SHEVA: 'ְ',     QAMATZ_QATAN: 'ׇ'
}